import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';

const GroupTitle = forwardRef<HTMLDivElement, RadixDropdown.DropdownMenuLabelProps>((props, ref) => {
  return <RadixDropdown.Label className="flex px-3 pt-2 pb-1 text-tertiary text-body-2" {...props} ref={ref} />;
});

export default GroupTitle;
